'use client';
import styled from 'styled-components';
import { colors, toRgba } from '@/styles';

export const BranchFileVersionSelect = styled.div<{ $alignment: 'row' | 'column' }>`
  flex: 1;
  display: flex;
  flex-direction: ${({ $alignment }) => ($alignment === 'row' ? 'row' : 'column')};
  gap: 10px;

  .prefix-icon {
    height: 14px;
    width: 14px;
    margin-right: 5px;
  }
`;

export const CommitOption = styled.div`
  .commitRef {
    font-family: var(--font-family-mono);
  }
  .commit-message {
    font-size: 0.8rem;
    margin: 5px -10px 0;
    padding: 5px 12px 0;
  }
  .commit-date {
  }
`;
